<template>
	<div class="page-main">
		<div class="main-head">
			<div class="breakcrumbs">教师团队  >  教师主页</div>
			<!-- <div class="back-btn">返回</div> -->
		</div>
		
		<div class="w1200">
			<!-- 教师信息 -->
			<div class="teacher-box" v-if="detail">
				<img class="pic" :src="detail.headImage || dfHead" alt="">
				<div class="info">
					<h3 class="name">{{detail.teacherName}}</h3>
					<div class="label">{{detail.orgName}}  |  {{detail.title}} {{detail.teacherTypeName}}</div>
					<div class="des">{{detail.introduction}}</div>
				</div>
			</div>
			
			<!-- 课程 -->
			<div class="course-wrap">
				<div class="tag-box">
					<span :class="{act:index==tagIndex}" v-for="(item,index) in tagList" :key="index"
						@click="changeTag(index)">{{item}}</span>
				</div>
				
				<!-- 主讲课程 -->
				<div v-if="tagIndex==0">
					<ul class="course-list">
						<li v-for="(item,index) in listInfo.list" :key="item.courseId" @click="goCourseDetail(item)" >
							<div v-if="item.courseLevelName" class="label" :class="item.courseLevelClass">{{item.courseLevelName}}</div>
							<img class="img" :src="item.courseImg || dfImg" alt="">
							<div class="info">
								<h3>{{item.courseName}}</h3>
								<div class="center">
									<p>{{item.orgName}} | {{item.teacherName}}</p>
									<span>{{item.termName}}</span>
								</div>
							</div>
							<div class="btm">
								<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
								<span class="learn-num">{{item.allChooseCount || 0}}人已学</span>
							</div>
						</li>
					</ul>
					<van-empty v-if="!listInfo.list.length>0"  description="没找到相应课程" />
					<!-- 分页 -->
					<div class="paging" v-if="listInfo.pagingList.length>1">
						<span class="prev" @click="changePaging(listInfo.pageNum-1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
						<span :class="{active:index==listInfo.pageNum-1}" v-for="(item,index) in listInfo.pagingList" :key="index" 
							@click="changePaging(item,'listInfo')">{{item}}</span>
						<span class="next" @click="changePaging(listInfo.pageNum+1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
					</div>
				</div>
				
				<!-- 参与建设课程 -->
				<div v-if="tagIndex==1">
					<ul class="course-list">
						<li v-for="(item,index) in listInfo2.list" :key="item.courseId" @click="goCourseDetail(item)" >
							<div v-if="item.courseLevelName" class="label" :class="item.courseLevelClass">{{item.courseLevelName}}</div>
							<img class="img" :src="item.courseImg || dfImg" alt="">
							<div class="info">
								<h3>{{item.courseName}}</h3>
								<div class="center">
									<p>{{item.orgName}} | {{item.teacherName}}</p>
								</div>
							</div>
							<div class="btm">
								<span class="term" :class="{gray:item.offerCoursesStu==3}" v-if="item.termName && item.offerCoursesStu!=4">{{item.termName}}</span>
								<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
								<span class="learn-num">{{item.allChooseCount || 0}}</span>
							</div>
						</li>
					</ul>
					<van-empty v-if="!listInfo2.list.length>0"  description="没找到相应课程" />
					<!-- 分页 -->
					<div class="paging" v-if="listInfo2.pagingList.length>1">
						<span class="prev" @click="changePaging(listInfo2.pageNum-1,'listInfo2')"><img src="../../static/img/ico-tri.png" alt=""></span>
						<span :class="{active:index==listInfo2.pageNum-1}" v-for="(item,index) in listInfo2.pagingList" :key="index" 
							@click="changePaging(item,'listInfo2')">{{item}}</span>
						<span class="next" @click="changePaging(listInfo2.pageNum+1,'listInfo2')"><img src="../../static/img/ico-tri.png" alt=""></span>
					</div>
				</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			tagList:['主讲课程','参与建设课程'],
			tagIndex:0,
			teacherId:'',	//教师id
			detail:null,	//教师详情
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:12,
				total:0,
				pagingList:[],
			},
			
			listInfo2:{	//建设课程列表
				list:[],
				pageNum:1,
				pageSize:12,
				total:0,
				pagingList:[],
			},
			
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		
		this.teacherId = this.$route.params.id || ''
		this.schoolsId = this.$route.query.schoolsId || ''
		this.getDetail()
		this.getList(3)
		this.getList(1)
		//this.getList2()
	},
  
	computed:{
		
	},
  
	methods:{
		//教师详情数据
		getDetail(){
			this.$axios({
				url:`/jxedu/api/site/findTeacherDetail/${this.teacherId}`,
			}).then(res=>{
				let detail = res.data
				switch(detail.teacherType){	//老师分类：1责任老师 3主讲老师
					case 1: detail.teacherTypeName = '责任老师'; break;
					case 3: detail.teacherTypeName = '主讲老师'; break;
				}
				this.detail = detail
			})
		},
		
		//获取主讲课程列表
		getList(teacherType){
			const {  pageSize, pageNum } = this.listInfo
			const { teacherId,schoolsId } = this
			this.$axios({
				url:`/jxedu/api/site/findLecturerCourse`,
				params:{
					schoolsId,
					teacherId,
					pageNum,
					pageSize,
					teacherType
				}
			}).then(res=>{
				let list = res.rows
				let total = res.total
				list.forEach(item=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'red'; break;
					}
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
				})
				
				let num = Math.ceil(total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				if(teacherType==3){
					this.listInfo.list = list
					this.listInfo.total = total
					this.listInfo.pagingList = pagingList
				}else if(teacherType==1){
					this.listInfo2.list = list
					this.listInfo2.total = total
					this.listInfo2.pagingList = pagingList
				}
				
			})
		},
		
		//获取教师参与建设课程列表
		// getList2(){
		// 	const {  pageSize, pageNum } = this.listInfo2
		// 	const { teacherId } = this
		// 	this.$axios({
		// 		url:`/jxedu/api/site/findBuildCourse`,
		// 		params:{
		// 			teacherId,
		// 			pageNum,
		// 			pageSize
		// 		}
		// 	}).then(res=>{
		// 		let list = res.rows
		// 		let total = res.total
				
		// 		let num = Math.ceil(total/pageSize)
		// 		let pagingList = []
		// 		if(num>0){
		// 			for(var i=0; i<num; i++){
		// 				pagingList.push(i+1)
		// 			}
		// 		}else{
		// 			pagingList.push(1)
		// 		}
		// 		this.listInfo2.list = list
		// 		this.listInfo2.total = total
		// 		this.listInfo2.pagingList = pagingList
		// 	})
		// },
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'listInfo':  //开放课堂
					this.getList(3);
					break;
				case 'listInfo2':  //建设课程
					this.getList(1);
					break;
			}
		},
		
		changeTag(index){
			this.tagIndex = index
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-course.less';
.teacher-box{
	box-sizing: border-box; padding:40px 22px 20px; display:flex;
	.pic{ width:200px; height:200px; margin-right:20px; }
	.info{
		flex:1; padding-top:10px;
		.name{ font-size:20px; color:#333333; font-weight: bold; line-height:20px; margin-bottom:12px; }
		.label{ font-size: 14px; line-height:16px; color:#999999; margin-bottom:12px;}
		.des{ 
			font-size: 16px; line-height:26px; color:#666666; height:130px; margin-bottom:70px;
		}
	}
}
.course-wrap{
	padding:20px 22px 60px; box-sizing: border-box;
	.course-list li{ 
		margin-right:12px; width: 280px;
		&:nth-child(4n+4){ margin-right:0; }
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/teacher-detial/tpl-pc.vue